import { Navigate, createBrowserRouter } from 'react-router-dom'
import { AuthWrapper } from 'components/layout/AuthWrapper/AuthWrapper'
import { SellerStatus } from 'pages/auth/SellerStatus/SellerStatus'

export const sellerStatusRouter = createBrowserRouter([
  {
    path: '/',
    element: <AuthWrapper />,
    children: [
      {
        index: true,
        element: <SellerStatus />
      },
      {
        path: '*',
        element: <Navigate to='/' />
      }
    ]
  }
])
